import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AdminDashboardSectionState, AdminDashboardStaffWorkload } from "@/types/dashboard";

export type DashboardStaffWorkloadState = AdminDashboardSectionState<AdminDashboardStaffWorkload>;

export const dashboardStaffWorkloadInitialState: DashboardStaffWorkloadState = {
  data: null,
  error: null,
};

const slice = createSlice({
  name: "dashboardStaffWorkload",
  initialState: dashboardStaffWorkloadInitialState,
  reducers: {
    setDashboardStaffWorkloadAction(state, { payload }: PayloadAction<AdminDashboardStaffWorkload | null>) {
      state.data = payload;
      state.error = null;
    },
    setDashboardStaffWorkloadErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload;
    },
  },
});

export const { setDashboardStaffWorkloadAction, setDashboardStaffWorkloadErrorAction } = slice.actions;
export default slice.reducer;
